import { render, staticRenderFns } from "./N_BbUpload.vue?vue&type=template&id=6dd167fc&scoped=true&"
import script from "./N_BbUpload.vue?vue&type=script&lang=js&"
export * from "./N_BbUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd167fc",
  null
  
)

export default component.exports